/// <amd-module name="Artifacts/Root/types/IPerson" />
export interface IPerson {
  /**
   * Person's email (optional)
   */
  email: string;
  /**
   * Person's Name
   */
  name: string;
  /**
   * Persons' Url
   */
  url: string;
}
